import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { FieldTree } from '@angular/forms/signals'
import { SopimusPalvelupaketti } from '@lemon/core-firebase/model/kayttaja'
import { AsiakkaanSopimuskausiService } from '../../_jaettu-lemonator/service/sopimuskausi.service'

export interface SopimusversioLomake {
  palvelupaketti: SopimusPalvelupaketti | null
  palkat: boolean | null
  sopimusversioVoimassaAlkaen: Date | null
}

@Component({
  selector: 'app-sopimusversio',
  templateUrl: './sopimusversio.component.html',
  styleUrls: ['./sopimusversio.component.css', './sopimuskaudet-v2.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakasAsetuksetSopimusversioComponent {
  @Input() lomake: FieldTree<SopimusversioLomake>
  @Input() hideVoimassaAlkaen: boolean = false

  palvelupaketit = this._sopimusService.palvelupaketit

  constructor(private _sopimusService: AsiakkaanSopimuskausiService) {}

  onkoVirhe<T>(kentta: FieldTree<T>, laji: string): boolean {
    return kentta()
      .errors()
      .some(virhe => virhe.kind === laji)
  }
}
